module.exports = __webpack_public_path__ + "static/media/user.ffe7946d.svg";